import React from "react";
import { Box, Button, CircularProgress, Container, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Formik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import AuthAPI from "../../../../services/auth-api";
import { loginValidation } from "../../../Auth/Auth.validation";

// import AuthAPI from "../../services/auth-api";
// import { loginValidation } from "./Auth.validation";

export default function LoginForm() {
  const navigate = useNavigate();

  const { loginAPI } = new AuthAPI();

  const initialValues = {
    email: "",
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={loginValidation}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          setSubmitting(true);
          setTimeout(async () => {
            const res = await loginAPI(values);

            if (res.ok) {
              navigate("/login-user-otp", {
                state: {
                  data: res.data,
                  tempEmail: values.email,
                },
              });
            } else {
              setFieldError("email", res.err);
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <TextField
                  fullWidth
                  autoComplete="off"
                  size="small"
                  name="email"
                  label="Email"
                  variant="outlined"
                  helperText={touched.email && errors.email}
                  error={touched.email && errors.email}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>

              <Grid size={12} textAlign="center">
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  size="large"
                  endIcon={
                    isSubmitting && <CircularProgress size="1.4rem" style={{ color: "#ffffff", marginLeft: 6 }} />
                  }
                  sx={{
                    "&.Mui-disabled": {
                      color: "#333333",
                      background: "#ddddddd",
                    },
                    width: 200,
                    marginBottom: 3,
                    marginTop: 1,
                    textTransform: "capitalize",
                  }}
                >
                  Request OTP
                </Button>

                <Typography typography="body2">
                  Not a Ram Fincorp DSA? <Link to="/">Register Now</Link>
                </Typography>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
